import render from '@/views/render'

render()
